export default {
  isDev() {
    return window.location.hostname === 'platform-dev.mikmak.tv';
  },
  isLocalHost() {
    return window.location.host.search('localhost') >= 0;
  },
  isPreviewChannel() {
    return /^mikmak-platform-development--[a-zA-Z0-9.-]*-[a-zA-Z0-9]{8}.web.app/.test(
      window.location.hostname,
    );
  },
  isProduction() {
    return window.location.hostname === 'platform.mikmak.tv';
  },
  getEnvironmentName() {
    switch (true) {
      case this.isPreviewChannel():
        return 'preview';
      case this.isDev():
        return 'development';
      case this.isProduction():
        return 'production';
      case this.isLocalHost():
        return 'local';
      default:
        return undefined;
    }
  },
};
